<template>
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-lockup">
        <div class="auth-wordmark">MLS Ingest</div>
        <div class="auth-parent-line">
          a <span class="auth-parent-mark">Brokurz</span> company
        </div>
      </div>
      <div class="auth-brand">Set your password</div>
      <div class="auth-sub">Finish your MLS Ingest admin invite</div>

      <Message v-if="info" severity="info" :closable="false" class="tw-mb-3">{{ info }}</Message>
      <Message v-if="error" severity="error" :closable="false" class="tw-mb-3">{{ error }}</Message>

      <form v-if="ready" @submit.prevent="submit">
        <div class="field">
          <label class="field-label">New password</label>
          <Password v-model="password" toggleMask inputClass="tw-w-full" class="tw-w-full" required />
        </div>
        <div class="field">
          <label class="field-label">Confirm password</label>
          <Password v-model="confirm" :feedback="false" toggleMask inputClass="tw-w-full" class="tw-w-full" required />
        </div>
        <Button type="submit" label="Save password & continue" class="tw-w-full" :loading="loading" />
      </form>
      <ProgressSpinner v-else style="width:36px;height:36px" strokeWidth="4" />
    </div>
  </div>
</template>

<script>
import { authState } from '../lib/auth'

export default {
  data() {
    return {
      ready: false,
      password: '',
      confirm: '',
      loading: false,
      error: null,
      info: 'Checking invite link…',
    }
  },
  async mounted() {
    try {
      await authState.exchangeCodeFromUrl()
      if (!authState.isAuthenticated) {
        this.error = 'Invite link is invalid or expired. Ask a super admin to resend.'
        this.info = null
        this.ready = true
        return
      }
      this.info = `Signed in as ${authState.email}. Choose a password to finish setup.`
      this.ready = true
    } catch (err) {
      this.error = err.message || 'Could not open invite'
      this.info = null
      this.ready = true
    }
  },
  methods: {
    async submit() {
      this.error = null
      if (this.password.length < 8) {
        this.error = 'Use at least 8 characters'
        return
      }
      if (this.password !== this.confirm) {
        this.error = 'Passwords do not match'
        return
      }
      this.loading = true
      try {
        await authState.updatePassword(this.password)
        this.$router.replace('/dashboard')
      } catch (err) {
        this.error = err.message || 'Could not set password'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f4f4f5;
}

.auth-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 1.75rem;
}

.auth-lockup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.22rem;
  margin-bottom: 1.15rem;
}

.auth-wordmark {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.06em;
  line-height: 1;
}

.auth-parent-line {
  display: inline-flex;
  align-items: baseline;
  gap: 0.28em;
  font-size: 0.68rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 1;
}

.auth-parent-mark {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: -0.055em;
}

.auth-brand {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.auth-sub {
  color: #71717a;
  font-size: 0.875rem;
  margin: 0.25rem 0 1.25rem;
}
</style>
